import Vue from "vue";
import format from "date-fns/format";
import api from "@/services/api";

// Endpoints whose /exportCsv actually returns a CSV file. Every other
// endpoint's /exportCsv returns an XLSX file (see the matching *Service
// on the API for the real format of each one).
const CSV_EXPORT_ENDPOINTS = [
  "peca-estudante",
  "peca-fornecedor",
  "peca-publicitaria",
  "peca-profissional-independente",
];

export async function exportExcel(endpoint, setLoading, friendlyName = "") {
  setLoading(true);
  try {
    const entityName = friendlyName || endpoint;
    const extension = CSV_EXPORT_ENDPOINTS.includes(endpoint)
      ? "csv"
      : "xlsx";
    const fileName =
      entityName +
      "_" +
      format(new Date(), "yyyy-MM-dd-HH-mm-ss") +
      "." +
      extension;
    const response = await api.get(endpoint + "/exportCsv", {
      responseType: "blob",
    });

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement("a");

    fileLink.href = fileURL;
    fileLink.setAttribute("download", fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
  } catch (err) {
    console.error(err);
    Vue.swal(
      "Oops!",
      "Ocorreu um problema ao exportar os dados. Por favor, tente novamente mais tarde."
    );
  } finally {
    setLoading(false);
  }
}

export async function login(
  email,
  password,
  setLoading,
  successCallback,
  errorCallback,
  isJurado = false
) {
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  try {
    setLoading?.(true);
    const params = new URLSearchParams();
    const processedEmail = isJurado ? email + ";jurado" : email;

    params.append("username", processedEmail);
    params.append("password", password);
    const response = await api.post("/login", params, config);
    localStorage.setItem("token@mf", response.data.access_token);

    const current = await api.get("/user/current");
    localStorage.setItem("user@mf", JSON.stringify(current.data));
    successCallback?.(current.data);
  } catch (e) {
    errorCallback?.(e);
  } finally {
    setLoading?.(false);
  }
}
